/* eslint-disable eqeqeq */
import React, { useState, useEffect, Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Dropdown, Select, Table, Tag, Drawer, Tooltip, Popover, Divider,
} from 'antd';
import {
  FilterOutlined,
  EditOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faArrowRightLong, faPen } from '@fortawesome/free-solid-svg-icons';
import Helpers from '@Apis/helpers';
import { toISTDate, entityNameEnum, filterTypeEnums } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import PriceListActions from '@Actions/inventory/priceListActions';
import CustomerActions from '@Actions/customerActions';
import searchIcon from '@Images/icons/icon-search.png';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import Restricted from '@Components/Restricted';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import PriceListForm from './PriceListForm';
import ViewPriceList from './ViewPriceList';
import SelectCustomer from '../../../Common/SelectCustomer';
import StateSelector from '../../../Common/SelectStates';
import PRZButton from '../../../Common/UI/PRZButton';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelper';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const PriceList = ({
  user,
  history,
  getPriceLists,
  priceLists,
  getPriceListsLoading,
  getCustomers,
  customers,
  deletePriceListLoading,
  updatePriceListStatusLoading,
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [status, setStatus] = useState('');
  const [call, setCall] = useState(false);
  const [showAddPriceListModal, setShowAddPriceListModal] = useState(false);
  const [showUpdatePriceListModal, setShowUpdatePriceListModal] = useState(false);
  const [showViewPriceListModal, setShowViewPriceListModal] = useState(false);
  const [priceListId, setPriceListId] = useState('');
  const [selectedPriceList, setSelectedPriceList] = useState(null);
  const [isUserReady, setIsUserReady] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(
    localStorage.getItem('prcz-page-columns-price-list')
      ? JSON.parse(localStorage.getItem('prcz-page-columns-price-list'))
      : {
        PRICE_LIST_CODE: {
          label: 'PRICE LIST CODE',
          visible: true,
        },
        PRICE_LIST_NAME: {
          label: 'Price List Name',
          visible: true,
        },
        LOCATION: {
          label: 'Location',
          visible: true,
        },
        PRICE_LIST_TYPE: {
          label: 'Price List Type',
          visible: true,
        },
        OFFER_DURATION: {
          label: 'Offer Duration',
          visible: true,
        },
        PRICING_SCHEME: {
          label: 'Pricing Scheme',
          visible: true,
        },
        VALID_TO: {
          label: 'Valid To',
          visible: true,
        },
        PRICING_RULE: {
          label: 'Pricing Rule',
          visible: true,
        },
      },
  );
  const [selectedPriceListForMobile, setSelectedPriceListForMobile] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);


  // states related to saved filters
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const fixedColumns = [
    'PRICE_LIST_CODE',
    'PRICE_LIST_NAME',
    'PRICE_LIST_TYPE',
    'PRICING_SCHEME',
  ];
  function getExpiryStatus(expiryDate) {
    const today = dayjs();
    const expiry = dayjs(expiryDate);
    const hoursDifference = expiry.diff(today, 'hour');

    if (hoursDifference > 24) {
      const daysDifference = Math.floor(hoursDifference / 24);
      if (daysDifference > 7) {
        const weeks = Math.floor(daysDifference / 7);
        return `Expires in ${weeks} week${weeks > 1 ? 's' : ''} `;
      }
      return `Expires in ${daysDifference} day${daysDifference > 1 ? 's' : ''}`;
    }

    if (
      hoursDifference === 0
      || hoursDifference > 1
      || hoursDifference > 0
      || hoursDifference === -1
    ) {
      return 'Expires Today';
    }

    if (hoursDifference >= -24) {
      const hoursAgo = Math.abs(hoursDifference);
      return `Expired ${hoursAgo} hour${hoursAgo > 1 ? 's' : ''} ago`;
    }

    const daysAgo = Math.abs(Math.floor(hoursDifference / 24));
    return `Expired ${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
  }
  const getDatesDiff = (fromDate, toDate) => {
    const today = dayjs();
    const diffInDays = dayjs(toDate).diff(dayjs(fromDate), 'day', false);
    if (diffInDays === 0) {
      return 'Today';
    }
    let diff = '';
    if (diffInDays > 360) {
      const years = Math.floor(diffInDays / 365);
      diff = `${years} Year${years > 1 ? 's' : ''}`;
    } else if (diffInDays > 180) {
      const months = Math.floor(diffInDays / 30);
      diff = `${months} Month${months > 1 ? 's' : ''}`;
    } else if (diffInDays > 28) {
      const weeks = Math.floor(diffInDays / 7);
      diff = `${weeks} Week${weeks > 1 ? 's' : ''}`;
    } else if (diffInDays > 0) {
      diff = `${diffInDays} Day${diffInDays > 1 ? 's' : ''}`;
    }
    return diff;
  };

  const priceListColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => {
          const getPricingRuleTextAndColor = (pricingRule) => {
            if (pricingRule === 'MARK_UP_PERCENTAGE') {
              return {
                text: 'Markup',
                color: 'green',
                arrow: <ArrowUpOutlined style={{ color: 'green' }} />,
              };
            }
            if (pricingRule === 'MARK_DOWN_PERCENTAGE') {
              return {
                text: 'Markdown',
                color: 'red',
                arrow: <ArrowDownOutlined style={{ color: 'red' }} />,
              };
            }
            return { text: '', color: 'black', arrow: null };
          };
          const { text, color, arrow } = getPricingRuleTextAndColor(
            record?.pricing_rule,
          );
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.price_list_doc_number}`} />
                </div>

              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">
                  <div className="mobile-list__card_item-name_wrapper">
                    <PRZText
                      text={`${record?.price_list_name}`}
                      className="mobile-list__card_item-name"
                    />
                  </div>

                  <PRZText
                    text={`Location - ${
                    record?.tenant_info?.find(
                      (item) => item.tenant_id === user?.tenant_info?.tenant_id,
                    )?.tenant_name || record?.tenant_info?.[0]?.tenant_name
                  }${
                    record?.tenant_info?.length > 1
                      ? ` and ${record?.tenant_info?.length - 1} others`
                      : ''
                  }`}
                    className="mobile-list__card_item-details"
                  />

                  <PRZText
                    text={`Price List Type - ${
                    record?.price_list_type
                      ? record?.price_list_type.split('_').join(' ').toProperCase()
                      : '-'
                  } ${record?.pricing_rule_percentage != null
                    ? `${Math.abs(record?.pricing_rule_percentage)}%`
                    : ''
                  }`}
                    className="mobile-list__card_item-details"
                  />

                </div>
              </div>

              <Divider className="mobile-list__card_divider" />

              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  <Popover
                    title={dayjs
                      .utc(record?.valid_to)
                      .utcOffset('+05:30')
                      .format('DD/MM/YYYY')}
                    placement="topLeft"
                    style={{ cursor: 'pointer' }}
                    trigger={['click']}
                  >
                    {record?.valid_to != null && (
                      <Tag
                        icon={<ExclamationCircleOutlined />}
                        color={
                        getExpiryStatus(
                          dayjs(record?.valid_to).format('YYYY-MM-DDTHH:mm:ss'),
                        )?.includes('Expires Today')
                          ? 'warning'
                          : getExpiryStatus(
                            dayjs(record?.valid_to).format('YYYY-MM-DDTHH:mm:ss'),
                          )?.includes('Expired')
                            ? 'error'
                            : 'green'
                        }
                      >
                        {getExpiryStatus(
                          dayjs(record?.valid_to).format('YYYY-MM-DDTHH:mm:ss'),
                        )}
                      </Tag>
                    )}
                  </Popover>
                </div>
                <div className="mobile-list__card_footer-right">
                  <PRZText
                    className="mobile-list__card__view-more_wrapper"
                    onClick={() => {
                      setSelectedPriceListForMobile(record);
                      setMoreDetailsDrawer(true);
                    }}
                    text={(
                      <span className="mobile-list__card__view-more-text_wrapper">
                        <span className="mobile-list__card__view-more-text">More Info</span>
                        <FontAwesomeIcon
                          className="mobile-list__card__view-more-icon"
                          icon={faAnglesRight}
                        />
                      </span>
                    )}
                  />
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: '#',
        render: (record) => (
          <div className="column-number__wrapper min-width-50">
            #
            {record?.price_list_doc_number}
          </div>
        ),
        fixed: 'left',
        className: !visibleColumns?.PRICE_LIST_CODE?.visible
          ? 'display-none'
          : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'LOCATION',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-85">
            <H3Text
              text={
                record?.tenant_info?.find(
                  (item) => item.tenant_id === user.tenant_info.tenant_id,
                )?.tenant_name || record?.tenant_info[0]?.tenant_name
              }
            />
            {record?.tenant_info?.length > 1 && (
              <Popover
                content={(
                  <div
                    style={{
                      maxHeight: '85px',
                      overflowY: 'auto',
                      width: '150px',
                    }}
                  >
                    <div
                      style={{
                        color: 'black',
                        fontWeight: '600',
                        fontSize: '13px',
                      }}
                    >
                      Selected Locations
                    </div>
                    {record?.tenant_info?.slice(1)?.map((item) => (
                      <div key={item?.tenant_name}>
                        <span>{item?.tenant_name.toProperCase()}</span>
                      </div>
                    ))}
                  </div>
                )}
              >
                <div
                  className="table-subscript tenant-info"
                >
                  {`and ${record?.tenant_info?.length - 1} others`}
                </div>
              </Popover>
            )}
          </div>
        ),
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'PRICE LIST NAME',
        render: (record) => (
          <div className="price-list min-width-130">
            {record?.price_list_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PRICE_LIST_NAME?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'PRICE LIST TYPE',
        render: (record) => {
          const getPricingRuleTextAndColor = (pricingRule) => {
            if (pricingRule === 'MARK_UP_PERCENTAGE') {
              return {
                text: 'Markup',
                color: 'green',
                arrow: <ArrowUpOutlined style={{ color: 'green' }} />,
              };
            }
            if (pricingRule === 'MARK_DOWN_PERCENTAGE') {
              return {
                text: 'Markdown',
                color: 'red',
                arrow: <ArrowDownOutlined style={{ color: 'red' }} />,
              };
            }
            return { text: '', color: 'black', arrow: null };
          };
          const { text, color, arrow } = getPricingRuleTextAndColor(
            record?.pricing_rule,
          );
          return (
            <div className="min-width-130">
              <div>
                {record?.price_list_type
                  ? record?.price_list_type.split('_').join(' ').toProperCase()
                  : '-'}
              </div>
              <div className="price-list">
                {arrow}
                <span style={{ color, fontSize: '11px', fontWeight: '600' }}>
                  {text}
                  {' '}
                  {record?.pricing_rule_percentage != null
                    ? `${Math.abs(record?.pricing_rule_percentage)}%`
                    : ''}
                </span>
              </div>
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PRICE_LIST_TYPE?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'VALIDITY',
        render: (text, record) => (
          <div className="min-width-85">
            {record?.valid_from && record?.valid_to ? (
              <Fragment>
                <H3Text
                  text={getDatesDiff(
                    toISTDate(record?.valid_from),
                    toISTDate(record?.valid_to),
                  )}
                  className="priceList__date-diff"
                />
                <div className="priceList__date-range">
                  {dayjs
                    .utc(record?.valid_from)
                    .utcOffset('+05:30')
                    .format('DD/MM/YYYY')}
                  &nbsp;
                  <FontAwesomeIcon icon={faArrowRightLong} />
                  &nbsp;
                  {dayjs
                    .utc(record?.valid_to)
                    .utcOffset('+05:30')
                    .format('DD/MM/YYYY')}
                </div>
              </Fragment>
            ) : (
              '-'
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.OFFER_DURATION?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'PRICING SCHEME',
        render: (record) => (
          <div className="price-list min-width-115">
            <div>
              {record?.pricing_scheme === 'VOLUME_PRICING'
                ? 'Slab Pricing'
                : record?.pricing_scheme
                  ? record?.pricing_scheme.split('_').join(' ').toProperCase()
                  : '-'}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PRICING_SCHEME?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'EXPIRY STATUS',
        render: (record) => (
          <div className="min-wdith-100">
            <Tooltip
              title={dayjs
                .utc(record?.valid_to)
                .utcOffset('+05:30')
                .format('DD/MM/YYYY')}
              placement="topLeft"
              style={{ cursor: 'pointer' }}
            >
              {record?.valid_to != null && (
                <Tag
                  icon={<ExclamationCircleOutlined />}
                  color={
                    getExpiryStatus(
                      dayjs(record?.valid_to).format('YYYY-MM-DDTHH:mm:ss'),
                    )?.includes('Expires Today')
                      ? 'warning'
                      : getExpiryStatus(
                        dayjs(record?.valid_to).format('YYYY-MM-DDTHH:mm:ss'),
                      )?.includes('Expired')
                        ? 'error'
                        : 'green'
                  }
                >
                  {getExpiryStatus(
                    dayjs(record?.valid_to).format('YYYY-MM-DDTHH:mm:ss'),
                  )}
                </Tag>
              )}
            </Tooltip>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.VALID_TO?.visible ? 'display-none' : '',
      },
      {
        title: '',
        key: 'action',
        render: (record) => (
          <div className="list__actions">
            <div
              className="list__actions-button list__actions-button-dark"
              onClick={() => {
                setShowViewPriceListModal(true);
                setPriceListId(record?.price_list_id);
                setSelectedPriceList(record);
              }}
            >
              View
            </div>
            {Helpers.getPermission(
              Helpers.permissionEntities.PRICE_LIST,
              Helpers.permissionTypes.UPDATE,
              user,
            ) && (
                <div
                  className="list__actions-button"
                  onClick={() => {
                    setPriceListId(record?.price_list_id);
                    setSelectedPriceList(record);
                    setShowUpdatePriceListModal(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPen} />
                </div>
              )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'right',
        className: 'list__actions-column',
      },
    ];

    return columns.filter((item) => !item.hidden);
  };



  const pushParamsToUrl = (
    currentPage,
    currentLimit,
    currentTenant,
    currentCustomer,
    currentState,
    word,
    currentStatus,
    selectedFilterView
  ) => {
    let url = '?tab=/price-lists';
    if (currentPage) url += `&page=${currentPage}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (word) url += `&keyword=${word}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (currentCustomer) url += `&customer=${currentCustomer}`;
    if (currentState) url += `&state=${currentState}`;
    if (currentStatus) url += `&status=${currentStatus}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };



  useEffect(() => {
    getCustomers('', selectedTenant || user?.tenant_info?.tenant_id, 1, 1000);
  }, [selectedTenant]);

  const statusOptions = [
    { label: 'Active', value: 'true' },
    { label: 'Inactive', value: 'false' },
  ];

  // common 
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => Number(item)) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'customer',
        filter_value: Helpers.getValueFromUrl('customer')
          ? Number(Helpers.getValueFromUrl('customer'))
          : null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'state',
        filter_value: Helpers.getValueFromUrl('state') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') ,
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'customer',
      filter_value: null,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'state',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'status',
      filter_value: 'true',
      filter_type: filterTypeEnums.STRING,
    },
  ], []);
  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PRICE_LIST,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    setSelectedFilterView(systemDefaultUserView);
  }, []);
  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setSelectedCustomer(Number(Helpers.getValueFromUrl('customer')) || null);
  //     setSelectedState(Helpers.getValueFromUrl('state'));
  //     setStatus(Helpers.getValueFromUrl('status') || 'true');
  //     setPage(Number(Helpers.getValueFromUrl('page') || page));
  //     setSelectedTenant(
  //       Helpers.getValueFromUrl('tenant')
  //         ? Helpers.getValueFromUrl('tenant')
  //           ?.split(',')
  //           ?.map((item) => Number(item))
  //         : [user?.tenant_info?.tenant_id],
  //     );
  //     setIsUserReady(true);
  //   }
  // }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');
      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);
      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        // common state
        setCurrentlyAppliedFilters(appliedFiltersFromURL);
        // temp state
        setPage(tempFilterValues.page || 1);
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedCustomer(tempFilterValues.customer);
        setSelectedState(tempFilterValues.state);
        setStatus(tempFilterValues.status);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(
        page,
        limit,
        selectedTenant,
        selectedCustomer,
        selectedState,
        searchKeyword,
        status,
        selectedFilterView
      );
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getPriceLists(
        selectedTenant?.filter((item) => !isNaN(item))?.length > 0
          ? selectedTenant?.join(',')
          : Helpers.getTenantEntityPermission(
            user?.user_tenants,
            Helpers.permissionEntities.SALES_ORDER,
            Helpers.permissionTypes.READ,
          )?.join(','),
        '',
        true,
        Helpers.getValueFromUrl('customer'),
        Helpers.getValueFromUrl('state'),
        Helpers.getValueFromUrl('page'),
        Helpers.getValueFromUrl('limit'),
        Helpers.getValueFromUrl('status'),
        Helpers.getValueFromUrl('keyword'),
        true,
      );
    }
  }, [
    selectedTenant,
    selectedCustomer,
    selectedState,
    searchKeyword,
    page,
    limit,
    call,
    status,
  ]);

  return (
    <Fragment>
      <div className="doc-list__wrapper doc-list__tab-content">
        {!user?.tenant_info?.sales_config?.addons?.price_list?.is_active && (
          <Restricted
            style={{
              top: '105px',
            }}
            isOrgActive
            moduleName="Price Lists"
          />
        )}
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={searchKeyword}
                        placeholder="Search here..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setPage(1);
                            setLimit(10);
                          }
                        }}
                        onChange={(event) => {
                          setSearchKeyword(event.target.value);
                          setPage(1);
                          setLimit(10);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(searchKeyword);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(
                  Helpers.permissionEntities.PRICE_LIST,
                  Helpers.permissionTypes.CREATE,
                  user,
                ) && (
                    <div className="doc-list__buttons-wrapper">
                      {/* <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ Add Price List"
                      onClick={() => {
                        setShowAddPriceListModal(true);
                      }}
                      customClass="inventory__header__add-button"
                    /> */}
                      <PRZButton
                        onClick={() => {
                          setShowAddPriceListModal(true);
                        }}
                        // buttonStyle={{ width: "120px" }}
                        className="add-button"
                      >
                        + Add Price List
                      </PRZButton>
                    </div>
                  )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    // common state
                    setCurrentlyAppliedFilters(currentSelectedViewFilters);
                    // temp states
                    setPage(tempFilterValues.page || 1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedCustomer(tempFilterValues.customer);
                    setSelectedState(tempFilterValues.state);
                    setStatus(tempFilterValues.status);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.PRICE_LIST}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag
                    closable
                    onClose={() => {
                      setSearchKeyword('');
                      setPage(1);
                    }}
                    color="#2d7df7"
                  >
                    Search for &nbsp;
                    <span>
                      <b>{searchKeyword}</b>
                    </span>
                  </Tag>
                )}
                {selectedTenant
                  && selectedTenant?.map((item) => (
                    <Tag
                      key={item}
                      closable
                      onClose={() => {
                        setPage(1);
                        setSelectedTenant(
                          selectedTenant?.filter((tId) => tId !== item),
                        );
                      }}
                      color="#2d7df7"
                    >
                      Business Unit - &nbsp;
                      <span>
                        <b>
                          {user?.user_tenants
                            ?.find((tenant) => tenant?.tenant_id == item)
                            ?.tenant_name?.toUpperCase()}
                        </b>
                      </span>
                    </Tag>
                  ))}
                {selectedCustomer && selectedCustomer && (
                  <Tag
                    closable
                    onClose={() => {
                      setPage(1);
                      setSelectedCustomer('');
                    }}
                    color="#2d7df7"
                  >
                    Customer - &nbsp;
                    <span>
                      <b>
                        {customers?.customers
                          ?.find(
                            (customer) => customer?.customer_id == selectedCustomer,
                          )
                          ?.customer_info?.customer_name?.toUpperCase()}
                      </b>
                    </span>
                  </Tag>
                )}
                {status && (
                  <Tag
                    closable
                    onClose={() => {
                      setPage(1);
                      setStatus('');
                    }}
                    color="#2d7df7"
                  >
                    Status - &nbsp;
                    <span>
                      <b>{status === 'true' ? 'Active' : 'Inactive'}</b>
                    </span>
                  </Tag>
                )}
                {selectedState && (
                  <Tag
                    closable
                    onClose={() => {
                      setPage(1);
                      setSelectedState('');
                    }}
                    color="#2d7df7"
                  >
                    State - &nbsp;
                    <span>
                      <b>{selectedState?.toUpperCase()}</b>
                    </span>
                  </Tag>
                )}
              </div>
            </div>
            {user && (
              <div className="doc-list__table-wrapper">
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        <H3Text
                          text={`${priceLists && priceLists?.count
                            ? priceLists?.count
                            : '0'
                            } Total Price List`}
                          className=""
                        />
                      </div>
                      <div className="doc-list__table-header__right">
                        <Dropdown
                          trigger={['click']}
                          placement="bottom"
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title">
                                  {' '}
                                  Select Business Unit
                                  {' '}
                                </div>
                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  showAll={false}
                                  noDropdownAlign
                                  isMultiple
                                  onChange={(value) => {
                                    setPage(1);
                                    setSelectedTenant(value);
                                  }}
                                  placeholder="Select Business Unit"
                                  inputClassName="orgInputContainer"
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(
                                    user?.user_tenants,
                                    Helpers.permissionEntities
                                      .PURCHASE_REQUEST,
                                    Helpers.permissionTypes.READ,
                                  )}
                                />
                              </div>

                              <div className="filter__container filter__container-section">
                                <div className="filter__title">
                                  {' '}
                                  Select Customer
                                  {' '}
                                </div>
                                <SelectCustomer
                                  selectedCustomer={selectedCustomer}
                                  hideTitle
                                  allowClear
                                  onChange={(value) => {
                                    setSelectedCustomer(value?.customer_id);
                                  }}
                                  tenantId={selectedTenant}
                                  disabled={getPriceListsLoading}
                                  containerClass="create-sales-order__input-row"
                                />
                              </div>

                              {user?.tenant_info?.country_code === 'IN' && (
                                <div className="filter__container filter__container-section">
                                  <div className="filter__title">
                                    {' '}
                                    Select State
                                  </div>
                                  <StateSelector
                                    allowClear
                                    selectedState={selectedState}
                                    showSearch
                                    onChange={(value) => {
                                      setSelectedState(value);
                                    }}
                                    hideTitle
                                    containerClassName="create-price-list__input-row__input"
                                    placeholder="Select State"
                                    inputClassName="orgInputContainer  create__right-input"
                                    disabled={getPriceListsLoading}
                                  />
                                </div>
                              )}
                              <div className="filter__container filter__container-section select">
                                <div className="filter__title ">
                                  Select Status
                                </div>
                                <PRZSelect
                                  allowClear
                                  value={status}
                                  showSearch
                                  onChange={(value) => {
                                    setStatus(value);
                                  }}
                                  hideTitle
                                  containerClassName="create-price-list__input-row__input"
                                  placeholder="Select Status"
                                  inputClassName="orgInputContainer  create__right-input"
                                  disabled={getPriceListsLoading}
                                  options={statusOptions}
                                />
                              </div>
                            </div>
                          )}
                        >
                          <div className="doc-list__action-buttons">
                            <div className="action-button">
                              <H3Text
                                text="Filters"
                                className="action-button-text"
                              />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        {/* <Dropdown
                            overlay={(
                              <div className="custom-columns__content">
                                <div className="custom-columns__content-section">
                                  <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                  {
                                        Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                          <div key={key}>
                                            <Checkbox
                                              disabled={fixedColumns.includes(key)}
                                              checked={visibleColumns[key]?.visible}
                                              onChange={() => {
                                                const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                                visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                                localStorage.setItem('prcz-page-columns-price-list', JSON.stringify(visibleColumnsCopy));

                                                setVisibleColumns(visibleColumnsCopy);
                                              }}
                                            >
                                              {visibleColumns[key]?.label}
                                            </Checkbox>
                                          </div>
                                        ))
                                  }
                                </div>
                                {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                  <div className="custom-columns__content-section">
                                    <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                    {
                                            Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                              <div key={key}>
                                                <Checkbox
                                                  disabled={fixedColumns.includes(key)}
                                                  checked={visibleColumns[key]?.visible}
                                                  onChange={() => {
                                                    const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                                    visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                                    localStorage.setItem('prcz-page-columns-product', JSON.stringify(visibleColumnsCopy));
                                                    setVisibleColumns(visibleColumnsCopy);
                                                  }}
                                                >
                                                  {visibleColumns[key]?.label}
                                                </Checkbox>
                                              </div>
                                            ))
                                    }
                                  </div>
                                ) : ''}
                              </div>
                            )}
                            trigger={['click']}
                            placement="bottomRight"
                          >
                            <div className="custom-columns__wrapper">
                              Customize Columns
                              <ControlOutlined />
                            </div>
                          </Dropdown> */}
                      </div>
                    </div>
                  )}
                  loading={
                    getPriceListsLoading
                    || deletePriceListLoading
                    || updatePriceListStatusLoading
                  }
                  showHeader
                  size="small"
                  scroll={!isMobileOrPortrait && priceLists?.data?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                  sticky={!isMobileOrPortrait && !!priceLists?.data?.length}
                  columns={priceListColumns()}
                  dataSource={priceLists?.data || []}
                  bordered
                  pagination={
                    {
                      defaultCurrent: page,
                      current: page,
                      total: priceLists?.count ? priceLists?.count : 0,
                      pageSize: limit,
                      position: ['bottomLeft'],
                      showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                      onChange: (page, pageSize) => {
                        setPage(page);
                        setLimit(pageSize);
                      },
                      showSizeChanger: true,
                      pageSizeOptions: [10, 25, 50, 100],
                    }
                  }
                  rowClassName={(record) => (record?.is_active ? '' : 'price-list-row__inactive')}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* CREATE PRICE LIST */}
      <Drawer
        open={showAddPriceListModal}
        width="640px"
        mask
        onClose={() => setShowAddPriceListModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '590px' }}>
            <H3Text
              text="Create New Price List"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowAddPriceListModal(false)}
            />
          </div>
        </div>
        <PriceListForm
          callback={() => {
            setShowAddPriceListModal(false);
            setCall(!call);
          }}
        />
      </Drawer>
      {/* UPDATE PRICE LIST */}
      <Drawer
        open={showUpdatePriceListModal}
        width="640px"
        mask
        onClose={() => setShowUpdatePriceListModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '590px' }}>
            <H3Text text="Update Price List" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowUpdatePriceListModal(false)}
            />
          </div>
        </div>
        <PriceListForm
          priceListId={priceListId}
          selectedTenantIds={selectedPriceList?.tenant_id}
          callback={() => {
            setShowUpdatePriceListModal(false);
            setCall(!call);
          }}
        />
      </Drawer>
      {/* VIEW PRICE LIST */}
      <Drawer
        open={showViewPriceListModal}
        width="880px"
        mask
        onClose={() => {
          setShowViewPriceListModal(false);
          setCall(!call);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '830px' }}>
            <H3Text text="View Price List" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowViewPriceListModal(false);
                setCall(!call);
              }}
            />
          </div>
        </div>
        <ViewPriceList
          priceListId={priceListId}
          selectedTenant={selectedPriceList?.tenant_id}
          callback={() => {
            setShowViewPriceListModal(false);
            setCall(!call);
          }}
        />
      </Drawer>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedPriceListForMobile?.price_list_doc_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          description={selectedPriceListForMobile?.description}
          customFields={selectedPriceListForMobile?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedPriceListForMobile, user: user })}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers,
  PriceListReducers,
  CustomerReducers,
}) => ({
  user: UserReducers.user,
  priceLists: PriceListReducers.priceLists,
  getPriceListsLoading: PriceListReducers.getPriceListsLoading,
  customers: CustomerReducers.customers,
  deletePriceListLoading: PriceListReducers.deletePriceListLoading,
  updatePriceListStatusLoading: PriceListReducers.updatePriceListStatusLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPriceLists: (
    tenantId,
    priceListId,
    isListScreen,
    customerId,
    states,
    page,
    limit,
    status,
    searchKeyword,
  ) => dispatch(
    PriceListActions.getPriceLists(
      tenantId,
      priceListId,
      isListScreen,
      customerId,
      states,
      page,
      limit,
      status,
      searchKeyword,
    ),
  ),
  updatePriceListStatus: (payload, callback) => dispatch(PriceListActions.updatePriceListStatus(payload, callback)),
  getCustomers: (keyword, tenantId, page, limit, customerId, callback) => dispatch(
    CustomerActions.getCustomers(
      keyword,
      tenantId,
      page,
      limit,
      customerId,
      callback,
    ),
  ),
  deletePriceList: (payload, callback) => dispatch(PriceListActions.deletePriceList(payload, callback)),
});

PriceList.propTypes = {
  getPriceLists: PropTypes.func,
  getPriceListsLoading: PropTypes.bool,
  priceLists: PropTypes.any,
  customers: PropTypes.any,
  user: PropTypes.any,
  history: PropTypes.func,
  getCustomers: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PriceList));
